import Component from '@glimmer/component';
import '@ember/object';
import '@ember/utils';
import 'moment-timezone';
import { paginatorPageLists } from '../lib/utility/pagination.js';
import 'ember-inflector';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'grid-x align-center\'>\n  <div class=\'cell\'>\n    <ul class=\'pagination text-center\'>\n      {{#each this.pageLists as |page|}}\n        <li>\n          <LinkTo class=\'{{page.class}}\' @query={{hash pag=page.link}}>\n            {{page.name}}\n          </LinkTo>\n        </li>\n      {{/each}}\n    </ul>\n  </div>\n</div>");

class BbPaginatorComponent extends Component {
  get pageLists() {
    const {
      meta
    } = this.args || {};
    const {
      total_pages,
      actual_page
    } = meta || {};
    if (total_pages && actual_page) {
      return paginatorPageLists(total_pages, actual_page);
    }
    return null;
  }
}
setComponentTemplate(TEMPLATE, BbPaginatorComponent);

export { BbPaginatorComponent as default };
//# sourceMappingURL=bb-paginator.js.map
